import { Component, OnInit, Input } from '@angular/core'

@Component({
  selector: 'progressbar',
  templateUrl: './progressbar.component.html',
  styleUrls: ['./progressbar.component.css'],
})
export class ProgressbarComponent implements OnInit {
  @Input() total = 0
  @Input() current = 0
  @Input() error
  @Input() showLabel = true

  constructor() {}

  ngOnInit() {}
}
